import { createContext, useContext, useReducer } from 'react';

const StepPhotoManagerContext = createContext();

export function StepPhotoManagerProvider({ children }) {
  const initialState = {
    step: 'Home'
  };

  function reducer(state, action) {
    switch (action.type) {
      case 'Home':
        return { step: 'Home' };
      case 'FotosPedido':
        return { step: 'FotosPedido' };
      case 'FotosGaleria':
        return { step: 'FotosGaleria' };
      case 'UploadFotosPedido':
        return { step: 'UploadFotosPedido' };
      case 'UploadFotosGaleria':
        return { step: 'UploadFotosGaleria' };
      case 'FinalizarPedido':
        return { step: 'FinalizarPedido' };

      default:
        return { step: 'Home' };
    }
  }

  const [steps, dispatch] = useReducer(reducer, initialState);

  return (
    <StepPhotoManagerContext.Provider value={{ steps, dispatch }}>
      {children}
    </StepPhotoManagerContext.Provider>
  );
}

export function useStepPhotoManager() {
  const context = useContext(StepPhotoManagerContext);

  if (!context) {
    throw new Error('useStepPhotoManager must be used within a StepPhotoManagerProvider');
  }

  return context;
}
